import { render, staticRenderFns } from "./AboutHowToUsesSection.vue?vue&type=template&id=c8905b20&scoped=true&"
import script from "./AboutHowToUsesSection.vue?vue&type=script&lang=js&"
export * from "./AboutHowToUsesSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutHowToUsesSection.vue?vue&type=style&index=0&id=c8905b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8905b20",
  null
  
)

export default component.exports